import React from 'react';

const Substitution = ({ className, width, height }: { className?: string; width?: number; height?: number }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_922_36605)">
        <path
          d="M1.89306 2.37012H1.45965L0 4.00163L1.45145 5.85574H1.89306V4.83055H4.69687V3.3953H1.89306V2.37012Z"
          fill="#FF0004"
        />
        <path
          d="M5.54851 0.524902H5.10691V1.55008H2.3031V2.98534H5.10691V4.01052H5.54031L6.99997 2.37902L5.54851 0.524902Z"
          fill="#06C000"
        />
      </g>
      <defs>
        <clipPath id="clip0_922_36605">
          <rect width="7" height="7" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Substitution;
